import { render, staticRenderFns } from "./PopUpGeneralDetailFile.vue?vue&type=template&id=0681d961&scoped=true&"
import script from "./PopUpGeneralDetailFile.vue?vue&type=script&lang=js&"
export * from "./PopUpGeneralDetailFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpGeneralDetailFile.vue?vue&type=style&index=0&id=0681d961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0681d961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0681d961')) {
      api.createRecord('0681d961', component.options)
    } else {
      api.reload('0681d961', component.options)
    }
    module.hot.accept("./PopUpGeneralDetailFile.vue?vue&type=template&id=0681d961&scoped=true&", function () {
      api.rerender('0681d961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpGeneralDetailFile.vue"
export default component.exports